import { FormEvent, useEffect, useState } from 'react';
import { DraggableModalPanel } from '../ui/DraggableModalPanel';
import { parseVideoEmbedUrl } from './parseVideoEmbedUrl';

type VideoEmbedModalProps = {
  open: boolean;
  onClose: () => void;
  onConfirm: (embedUrl: string) => void;
};

export function VideoEmbedModal({ open, onClose, onConfirm }: VideoEmbedModalProps) {
  const [url, setUrl] = useState('');
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    if (!open) return;
    setUrl('');
    setError(null);
  }, [open]);

  function handleSubmit(event: FormEvent): void {
    event.preventDefault();
    const embedUrl = parseVideoEmbedUrl(url);
    if (!embedUrl) {
      setError('URL não reconhecida. Use YouTube, Vimeo, Loom ou um link de embed.');
      return;
    }
    onConfirm(embedUrl);
    onClose();
  }

  return (
    <DraggableModalPanel
      open={open}
      title="Inserir vídeo"
      subtitle="Cole a URL do YouTube, Vimeo, Loom ou de um embed."
      onClose={onClose}
      className="w-full max-w-md"
      footer={
        <div className="flex flex-wrap justify-end gap-2">
          <button type="button" className="erp-btn-secondary" onClick={onClose}>
            Cancelar
          </button>
          <button type="submit" form="rte-video-embed-form" className="erp-btn-primary">
            Inserir
          </button>
        </div>
      }
    >
      <form id="rte-video-embed-form" className="space-y-3" onSubmit={handleSubmit}>
        <label className="erp-label-block">
          URL do vídeo
          <input
            className="erp-input"
            type="url"
            value={url}
            onChange={(e) => {
              setUrl(e.target.value);
              if (error) setError(null);
            }}
            placeholder="https://www.youtube.com/watch?v=…"
            autoFocus
          />
        </label>
        {error ? <p className="text-sm text-red-600">{error}</p> : null}
      </form>
    </DraggableModalPanel>
  );
}
